import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FieldBuilder from "../../form-components/field-builder";
import { IParamDetails } from "../../../models/param/resopnse";
import EndPoints from "../../../services/end-points";
import { IStore } from "../../../models/store/response";

interface IProps {
  type?: number;
  details?: IParamDetails;
}

const CopyForm: React.FC<IProps> = ({ type, details }) => {
  const { t } = useTranslation();
  const [stores, setStores] = useState<IStore[]>();
  useEffect(() => {
    const getStores = async () => {
      try {
        const { data } = await EndPoints.store.getAllStores({
          light: true,
          perPage: -1,
        });
        setStores(data.data);
      } catch (error) {
      } finally {
      }
    };
    getStores();
  }, []);
  return (
    <>
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <FieldBuilder
            key={"secondStoreId"}
            name={`secondStoreId`}
            label={`${t("store")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              options: stores?.map((s) => ({ label: s.name, value: s.id })),
            }}
            rules={{ required: true }}
          />
        </Col>
      </Row>
    </>
  );
};

export default CopyForm;
